import { createContext, useContext, useState, useCallback } from 'react';
import OfferteModal from '../components/OfferteModal';

const OfferteContext = createContext(null);

export const OfferteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openOfferte = useCallback((data = {}) => {
    setPrefill(data);
    setOpen(true);
  }, []);

  const closeOfferte = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <OfferteContext.Provider value={{ openOfferte, closeOfferte }}>
      {children}
      <OfferteModal open={open} onClose={closeOfferte} prefill={prefill} />
    </OfferteContext.Provider>
  );
};

export const useOfferte = () => {
  const ctx = useContext(OfferteContext);
  if (!ctx) throw new Error('useOfferte must be used within OfferteProvider');
  return ctx;
};
